<template>
    <vxe-table
        ref="elTable"
        v-bind="$attrs"
        v-loading="loading"
        border
        width="100%"
        align="center"
        class="vxe-table-box"
        show-overflow="tooltip"
        show-header-overflow="tooltip"
        :tooltip-config="{ zIndex: 9999 }"
        :size="size"
        :data="newRows"
        :height="height"
        :row-class-name="rowClassHandler"
        :cell-style="customCellStyle"
        :column-config="{ resizable: true }"
        :row-config="{isHover: true}"
        :scroll-x="{enabled: true}"
        :scroll-y="{enabled: true}"
        :checkbox-config="checkboxConfigChecked"
        @cell-click="rowClick"
        @sort-change="sortChange"
        @cell-dblclick="handleCellDblClick"
        @checkbox-all="handleSelectionAll"
        @checkbox-change="handleSelectionChange"
    >
        <vxe-column
            v-if="selection"
            type="checkbox"
            width="40"
            align="center"
            fixed="left"
        ></vxe-column>
        <vxe-column
            v-for="(col, cIndex) in columns"
            :key="col.prop + '' + cIndex"
            :fixed="col.fixed"
            :title="col.label"
            :minWidth="col.width"
            :sortable="col.sort"
            :field="col.prop"
            :show-header-overflow="showOverflowTooltip(col)"
        >
            <template #header>
                <slot v-bind="{ col }" name="col-header">
                    {{ col.label }}
                </slot>
            </template>
            <template #default="{ row, $rowIndex: rIndex }">
                <template v-if="!col.type">{{ row[col.prop] }}</template>
                <template v-else-if="col.type === 'select'">{{
                    dictFormat(row[col.prop], col.optionsKey)
                }}</template>
                <template v-else-if="col.type === 'file'">
                    <div class="demo-image__preview">
                        <el-image
                            :preview-src-list="[row[col.prop]]"
                            :src="row[col.prop]"
                            style="width: 32px; height: 32px"
                        >
                        </el-image>
                    </div>
                </template>
                <template v-else-if="col.type === 'fileList'">
                    <div
                        class="demo-image__preview"
                        v-if="row[col.prop].length"
                    >
                        <el-image
                            :preview-src-list="row[col.prop]"
                            :src="row[col.prop][0]"
                            style="width: 32px; height: 32px"
                        >
                        </el-image>
                    </div>
                </template>
                <template v-else-if="col.type === 'photos'">
                    <div
                        v-if="row[col.showPhotosFlag]"
                        style="line-height: 0px;"
                    >
                        <img
                            src="@/assets/photos.png"
                            @click.stop="$emit('photosClick', col.event, row)"
                            style="width: 20px; cursor: pointer;">
                    </div>
                </template>
                <template v-else-if="col.type === 'input'">
                    <el-input
                        class="edit-input"
                        v-model.trim="row[col.prop]"
                        :maxlength="row[col.maxlength] "
                        @input="$emit('onInput', row[col.prop], col.prop, row)"
                    ></el-input>
                </template>
                <template v-else-if="col.type === 'link'">
                    <el-button
                        type="text"
                        size="mini"
                        @click.stop="handleLinkClick(row[col.prop], row[col.requestParam])"
                    >
                        {{ row[col.prop] }}
                    </el-button>
                    <span></span>
                </template>
                <template v-else-if="col.type === 'button'">
                    <el-button
                        type="text"
                        size="mini"
                        @click.stop="
                            $emit('btnClick', row[col.prop], col.prop, row)
                        "
                    >
                        {{ row[col.prop] }}
                    </el-button>
                </template>
                <slot
                    v-else
                    v-bind="{ col, row, rIndex }"
                    name="col-append"
                ></slot>
            </template>
        </vxe-column>
        <!-- 操作 -->
        <vxe-column
            v-if="actionColShow"
            title="操作"
            :width="actionColWidth"
            fixed="right"
        >
            <template #default="{ row, $rowIndex: rIndex }">
                <template v-if="actions.type === 'dropdown'">
                    <el-dropdown>
                        <span class="el-dropdown-link">
                            {{ actions.title || '操作'
                            }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <template v-for="(e, eIndex) in actions.list">
                                    <el-dropdown-item
                                        class="dropdown-item"
                                        v-if="(e.displayRule && typeof (e.displayRule) === 'function') ? e.displayRule(row) : true"
                                        :key="eIndex"
                                        @click.stop="
                                            actionClick(e.event, row, rIndex)
                                        "
                                    >
                                        {{ e.label }}</el-dropdown-item
                                    >
                                </template>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </template>
                <template v-else>
                    <template v-for="(e, eIndex) in actions.list">
                        <el-button
                            v-if="(e.displayRule && typeof(e.displayRule) === 'function') ? e.displayRule(row) : true"
                            :key="eIndex"
                            size="mini"
                            type="text"
                            @click.stop="actionClick(e.event, row, rIndex)"
                        >
                            {{ e.label }}
                        </el-button>
                    </template>
                </template>
            </template>
        </vxe-column>
    </vxe-table>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'PerformanceVxeTable',
    props: {
        actions: {
            type: Object,
            default () {
                return {
                    list: []
                };
            },
            validator: function (obj) {
                return !!obj.list;
            }
        },
        loading: {
            type: Boolean,
            default () {
                return false;
            }
        },
        columns: {
            type: Array,
            required: true,
            default () {
                return [];
            }
        },
        rows: {
            type: Array,
            required: true,
            default () {
                return [];
            }
        },
        checkMethod: {
            default () {
                return function ({ row }) {
                    return true;
                };
            }
        },
        selection: {
            type: Boolean,
            default () {
                return false;
            }
        },
        customCellStyle: {
            type: Function,
            default: () => ({})
        },
        index: {
            type: Boolean,
            default () {
                return false;
            }
        },
        size: {
            default () {
                return 'medium';
            }
        },
        height: {
            default () {
                return '100%';
            }
        }
    },
    data () {
        return {
            newRows: [],
            checkboxConfigChecked: {
                checkField: 'checkboxConfigChecked',
                trigger: 'row',
                checkMethod: this.checkMethod
            },
            multipleSelection: []
        };
    },
    computed: {
        actionColShow () {
            return this.actions.list && this.actions.list.length > 0;
        },
        actionColWidth () {
            const btnWidth = 50;
            return this.actions.fixedWidth || btnWidth * this.actions.list.length;
        }
    },
    onMounted () {},
    methods: {
        actionClick (event, row, rIndex) {
            this.$emit('action-click', event, row, rIndex);
        },
        rowClassHandler ({ row }) {
            return this.multipleSelection.includes(row) ? 'selected-row' : '';
        },
        // 点击勾选当前行的复选框
        rowClick (row) { },
        dictFormat (value, options) {
            const foundItem = options.find(item => item.value === value);
            return foundItem ? foundItem.label : value;
        },
        // 排序
        sortChange (column) {
            this.$emit('sortChange', column);
        },
        handleCellDblClick ({ row, column }) {
            this.$emit('cell-dblclick', row, column);
        },
        handleSelectionAll (val) {
            if (this.selection) {
                this.multipleSelection = val.checked ? this.newRows : [];
                this.$emit('selection-change', this.multipleSelection);
            }
        },
        handleSelectionChange (val) {
            // 配置多选的情况下
            if (this.selection) {
                this.multipleSelection = this.$refs.elTable.getCheckboxRecords();
                this.$emit('selection-change', this.multipleSelection);
            }
        },
        // 添加showOverflowTooltip，就不需要return _
        showOverflowTooltip (col) {
            return _.get(col, 'showTooltip', true);
        },
        handleLinkClick (url, requestParam) {
            const requestUrl = this.appendParamsToUrl(url, requestParam);
            window.open(requestUrl);
        },
        handleDownload (url) {
            window.open(url);
        },
        appendParamsToUrl (url, params) {
            // 检查参数是否为空对象
            if (Object.keys(params).length === 0) {
                return url;
            }
            // 构造参数字符串
            var paramStr = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
            // 检查 URL 中是否已经有查询字符串
            var separator = url.includes('?') ? '&' : '?';
            // 拼接 URL 和参数字符串
            return url + separator + paramStr;
        }
    },
    watch: {
        rows: {
            handler (newVal, oldVal) {
                this.newRows = newVal.map((item, index) => {
                    item.$rowIndex = index;
                    return item;
                });
                this.newRows.forEach(item => {
                    if (!item.hasOwnProperty('checkboxConfigChecked')) {
                        item.checkboxConfigChecked = false;
                    }
                });
            },
            immediate: true,
            deep: true
        }
    }
};
</script>
<style lang="less">
@import url('../style/virtualTable.less');
</style>
